import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function StickyHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-wellness-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-160">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-161">
        <div className="font-serif font-bold text-xl text-wellness-dark" data-id="element-162">
          Cuerpo en Calma
        </div>
        <a href="https://cuerpoencalma.it.com/cart/49295445262573:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('sticky_header_cta')} className="bg-wellness-gold text-white px-5 py-2 rounded-full font-bold text-sm tracking-wide shadow-lg hover:bg-yellow-600 transition-colors" data-id="element-163">
          Quiero mi guía
        </a>
      </div>
    </motion.header>;
}